import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_J_CASH_IN = '/spe-j-cash-in';
let SpeJCashInProxy = class SpeJCashInProxy {
    constructor(api) {
        this.api = api;
    }
    generateBillet(value, uuidAccountPaymet, uuidWhitelabel) {
        const uri = `${SPE_J_CASH_IN}/api/self-billet-cash-in`;
        return this.api.post(uri, {
            value,
            uuidAccountPaymet,
            uuidWhitelabel
        });
    }
    /**
     * Metodo usado para geracao dos boletos de terceiros (como boletos de cobranca)
     * @param body
     */
    generateBilletWithObject(body) {
        const uri = `${SPE_J_CASH_IN}/api/self-billet-cash-in`;
        return this.api.post(uri, body);
    }
    getBilletsByUuidAccountPayment(uuidAccountPayment) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getBilletsByUuidAccountPaymentAndType(uuidAccountPayment, type) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/type/${type}`;
        return this.api.get(uri);
    }
    getBilletsByUuid(uuid) {
        const uri = `${SPE_J_CASH_IN}/api/billets/uuid-billet/${uuid}`;
        return this.api.get(uri);
    }
    getBilletsByTransactionId(transactionId) {
        const uri = `${SPE_J_CASH_IN}/api/billets/transaction-id/${transactionId}`;
        return this.api.get(uri);
    }
    getBilletsByUuidAccountPaymentAndPeriod(uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/period/?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getBilletsByUuidAccountPaymentAndPeriodAndType(uuidAccountPayment, type, dateInitial, dateEnd) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/type/${type}/period/?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/finished/${isFinished}/period/?startDate=${dateInitial}&endDate=${dateEnd} `;
        return this.api.get(uri);
    }
    getAllStatusDataByStatus(uuidAccountPayment, type, status, dateInitial, dateEnd) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/type/${type}/status/${status}?startDate=${dateInitial}&endDate=${dateEnd} `;
        return this.api.get(uri);
    }
};
SpeJCashInProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJCashInProxy = __decorate([
    Injectable()
], SpeJCashInProxy);

const SPE_J_CHECK_EVENT = '/spe-j-check-event';
let SpeJCheckEventProxy = class SpeJCheckEventProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * @description Valida se a operação está autorizada
     * @param checkEventBody
     */
    validateOperation(checkEventBody) {
        const uri = `${SPE_J_CHECK_EVENT}/api/check-event/`;
        return this.api.post(uri, checkEventBody);
    }
};
SpeJCheckEventProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJCheckEventProxy = __decorate([
    Injectable()
], SpeJCheckEventProxy);

const SPE_J_FUNDS = '/spe-j-funds';
let SpeJFundsProxy = class SpeJFundsProxy {
    constructor(api) {
        this.api = api;
    }
    getCheckBalance(uuidWhilabel, uuidAccountPayment) {
        const uri = `${SPE_J_FUNDS}/api/check-balance/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getSumMoviments(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/check-sum-moviments/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}/start-date/${dateInitial}/end-date/${dateEnd}`;
        return this.api.get(uri);
    }
    getCheckStatement(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getLatestTransaction(uuidWhilabel, uuidAccountPayment, quantityRegisters) {
        const uri = `${SPE_J_FUNDS}/api/statement/last-registers/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}/number/${quantityRegisters}`;
        return this.api.get(uri);
    }
};
SpeJFundsProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJFundsProxy = __decorate([
    Injectable()
], SpeJFundsProxy);

const SPE_N_ACCOUNT = '/spe-n-account';
let SpeNAccountProxy = class SpeNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getNotifications(uuid) {
        // const uri = `${SPE_N_ACCOUNT}/v1/notificatios/${uuid}`;
        // return this.api.get(uri);
        let notifications = [
            {
                title: "Bem-vindo(a)",
                message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries",
                // date: new Date,
                read: false
            },
        ];
        return [];
    }
    confirmReading(uuid, notification) {
        const uri = `${SPE_N_ACCOUNT}/v1/notificatios/${uuid}`;
        return this.api.put(uri, notification);
    }
    getNotificationData(uuidAccount) {
        return [{
                uuidNotification: "123123123213",
                type: 1,
                account_owner: "Dono Da Conta TED",
                transfer_value: 50,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123243",
                type: 2,
                account_owner: "Dono Da Conta ON_US",
                transfer_value: 50,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123214",
                type: 3,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123215",
                type: 4,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                type: 5,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                type: 6,
                establishment: "estabelecimento Estabelecimento",
                value: 1250,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                third_party: "terceiro Terceiro",
                value: 500,
                type: 7,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                third_party: "terceiro Terceiro",
                value: 500,
                type: 8,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                type: 9,
                third_party: "terceiro Terceiro",
                value: 6700,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                third_party: "terceiro Terceiro",
                value: 540,
                type: 10,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                dateFormatted: "05/05/1999",
                type: 11,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                phone_number: "(23) 9999-4444",
                value: 540,
                type: 12,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                white_label: "LogBank",
                type: 13,
                date: (new Date()).getDate()
            }];
    }
};
SpeNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccountProxy = __decorate([
    Injectable()
], SpeNAccountProxy);

const SPE_N_ACCOUNT$1 = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    generateQrcode(uuidAccountPayment, value) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/generate-qr-onus`;
        return this.api.post(uri, { uuidAccountPayment, value });
    }
    statusQrcode(encode) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/status-qr-onus/${encode}`;
        return this.api.post(uri, {});
    }
    /**
     * remove o cartao da wallet
     * @param uuidCard
     * @returns
     */
    deleteWalletCard(uuidCard) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/wallet/delete/${uuidCard}`;
        return this.api.put(uri, {});
    }
};
SpeNAccountsProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccountsProxy = __decorate([
    Injectable()
], SpeNAccountsProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCardTax(uuidWhiteLabel, uuidAccountPayment, codeOperation) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/taxes-tariff/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/code-operation/${codeOperation}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNAccountProxy = __decorate([
    Injectable()
], SpeViewNAccountProxy);

let UiPxCashInModule = class UiPxCashInModule {
};
UiPxCashInModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNAccountProxy,
            SpeNAccountsProxy,
            SpeJFundsProxy,
            SpeJCashInProxy,
            SpeJCheckEventProxy,
            SpeViewNAccountProxy,
            ConfigService
        ]
    })
], UiPxCashInModule);

/*
 * Public API Surface of ui-px-cashin
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeJCashInProxy, SpeJCheckEventProxy, SpeJFundsProxy, SpeNAccountProxy, SpeNAccountsProxy, SpeViewNAccountProxy, UiPxCashInModule };
//# sourceMappingURL=wlp-ui-px-cashin.js.map
